module.exports = __webpack_public_path__ + "static/video-3efdb867f0d037efc6a239e522780293.png";